import { render, staticRenderFns } from "./CmgRewardDetailModal.vue?vue&type=template&id=0aad0834&scoped=true&lang=pug"
import script from "./cmg-reward-detail-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-reward-detail-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardDetailModal.vue?vue&type=style&index=0&id=0aad0834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad0834",
  null
  
)

export default component.exports